import {
    post,
    get
} from '../util/crmAxios';
import {
    Message
} from 'element-ui';
// const baseUrl = 'http://192.168.31.152:8080'
import { getBaseUrl } from '../util/config'

// 登录
export const login = () => post('/ProductCenter/GetProductList', {
    "Where": {
        "ProductName": "2017-ACCA"
    },
    "PageIndex": 1,
    "PageSize": 2,
    "OrderBy": "ProductID",
    "SortCol": ""
})

const objParam = {
    "Where": {},
    "PageIndex": 1,
    "PageSize": 2,
    "OrderBy": "ProductID",
    "SortCol": ""
}

//数据字典
export const GetDictionaryByTypeId = (objParam = {}) => {
    return get('/Dictionary/GetDictionaryByTypeId', objParam);
}

// 汉天分机用户树
export const GetUserDepartmentTreeForTel = (objParam = {}) => {
    return get('DataStru/GetUserDepartmentTreeForTel?MainRole=MainRole', objParam);
}


// 任务分机详情
export const QueryTaskAgentList = (objParam = {}) => {
    return post('/HantianAutoCall/QueryTaskAgentList', objParam);
}
// 删除队列分机
export const RemoveQueueMember = (objParam = {}) => {
    return post('/HantianAutoCall/RemoveQueueMember', objParam);
}

// 任务状态详情
export const QueryCallTaskStatusInfo = (objParam = {}) => {
    return post('/HantianAutoCall/QueryCallTaskStatusInfo', objParam);
}

// 任务编辑
export const SaveGroupInfo = (objParam = {}) => {
    return post('/HantianAutoCall/SaveGroupInfo', objParam);
}

// 外呼任务删除
export const CallTaskDelete = (objParam = {}) => {
    return post('/HantianAutoCall/CallTaskDelete', objParam);
}

// 外呼任务列表
export const  QueryCallTask = (objParam = {}) => {
    return post('/HantianAutoCall/QueryCallTask', objParam);
}

// 自动外呼创建任务
export const CreateCallTask = (objParam = {}) => {
    return post('/HantianAutoCall/CreateCallTask', objParam);
}

export const GetBotCallRecordList = (objParam = {}) => {
    return post('/hantianbotautocall/getbotcallrecordlist', objParam);
}

// 修改线索的客户意向度
export const UpdateClueIntentionGrade = (objParam = {}) => {
    return post('/ClueFollow/updateclueintentiongrade', objParam);
    // return post('http://127.0.0.1:4523/m1/7678070-7420159-default/ClueFollow/updateclueintentiongrade', objParam);
}

// 操作外呼任务状态
export const OperateBotCallTask = (objParam = {}) => {
    return post('/hantianbotautocall/operatebotcalltask', objParam);
    // return post('http://127.0.0.1:4523/m1/7678070-7420159-default/pangu/hantianbotautocall/operatebotcalltask', objParam);
}

// 获取机器人外呼任务列表
export const QueryRobotCallTask = (objParam = {}) => {
    return post('/hantianbotautocall/getbotcalltasklist', objParam);
    // return post('http://127.0.0.1:4523/m2/7678070-7420159-default/402469889', objParam);
}

// 获取话术模板列表
export const GetSpeechTemplates = () => {
    return get('/hantianbotautocall/getallproject');
    // return get('http://127.0.0.1:4523/m2/7678070-7420159-default/402356448');
}

// 获取任务列表
export const GetTaskList = () => {
    return get('/hantianbotautocall/getallcalltask');
    // return get('http://127.0.0.1:4523/m2/7678070-7420159-default/402367751');
}

// 新增或追加自动外呼任务
export const AddOrAppendCallTask = (objParam = {}) => {
    return post('/hantianbotautocall/addorappendcalltask', objParam);
    // return post('http://127.0.0.1:4523/m2/7678070-7420159-default/402389774', objParam);
}

// 查询线索在外呼任务中的沟通记录详情
export const GetBotCallRecordDetail = (objParam = {}) => {
    return post('/hantianbotautocall/getbotcallrecorddetail', objParam);
    // return post('http://127.0.0.1:4523/m1/7678070-7420159-default/pangu/hantianbotautocall/getbotcallrecorddetail', objParam);
}

// 部门树查询
export const GetUserDepartmentTreeOnly = (objParam = {}) => {
    return get('/DataStru/GetUserDepartmentTreeOnly', objParam);
}

//创建邀约
export const CreateLiveRoom = (objParam = {}) => {
    return post('/ListenInvitation/CreateLiveRoom', objParam);
}

//重新邀约
export const ReInvite = (objParam = {}) => {
    return post('/ListenInvitation/ReInvite', objParam);
}
//取消邀约
export const ListenCancel = (objParam = {}) => {
    return post('/ListenInvitation/ListenCanle', objParam);
}

//统计试听数据
export const ListenStatisticsInfo = (objParam = {}) => {
    return post('/ListenInvitation/ListenStatisticsInfo', objParam);
}

//根据时间，试听方式，项目返回直播间列表
export const GetUserRoomList = (objParam = {}) => {
    return post('/ListenInvitation/GetUserLiveRoomList', objParam);
}
//试听模糊搜索
export const ListenVagueSeach = (objParam = {}) => {
    return post('ListenInvitation/ListenVagueSeach', objParam);
}
//获取直播详情
export const GetLiveRoomInfo = (objParam = {}) => {
    return post('ListenInvitation/GetLiveRoomInfo', objParam);
}
//获取试听课程列表
export const GetCourseExperience = (objParam = {}) => {
    return post('ListenInvitation/GetCourseExperience', objParam);
}
//获取试听账号
export const GetListenAccount = (objParam) => get("/ListenInvitation/GetListenAccount", objParam);

// 联系人新增或修改
export const ModifyContact = (objParam = {}) => {
    return post('/ClueFollow/ModifyContact', objParam);
}
// 联系人新增或修改
export const getModifyContact = (objParam = {}) => {
    return get('/ClueFollow/GetModifyContact', objParam);
}
// 客户查询
// 客户列表接口1
export const getGeClueBaseList = (objParam) => post('/Clue/GetClueBaseList', objParam);
// 客户列表接口2
// export const getGeClueMoreList = (objParam) => post('/Clue/GetClueMoreList', objParam);
export const getGeClueMoreList = (objParam) => post('/Clue/GetClueMoreListByGuids', objParam);

// 客户列表 分页
export const GetClueSearchCount = (objParam) => post('/Clue/GetClueSearchCount', objParam);
// 客户跟进
export const QuickClueFollowInfo = (objParam) => post('/ClueFollow/QuickClueFollowInfo', objParam);
// 保存跟进信息
export const UpdateClueFollowInfo = (objParam) => post('/ClueFollow/UpdateClueFollowInfo', objParam);
//修改跟进信息
export const UpdateClueInfo = (objParam) => post('/ClueFollow/UpdateClueInfo', objParam);

// 客户联系
// export const GetPersonContacts = (objParam) => get('/ClueFollow/GetPersonContacts', objParam);
// 客户信息
export const GetFollowClueInfo = (objParam) => get('/ClueFollow/GetFollowClueInfo', objParam);
const GMAIL_REQUEST_OPTIONS = {
    timeout: 300000
};
// Gmail 绑定状态
export const GetGmailBindingStatus = (objParam = {}) => get('/ClueGmail/GetBindingStatus', objParam, GMAIL_REQUEST_OPTIONS);
// 获取 Gmail 授权地址
export const GetGmailAuthUrl = (objParam = {}) => get('/ClueGmail/GetAuthUrl', objParam, GMAIL_REQUEST_OPTIONS);
// 解绑公共 Gmail
export const DisconnectGmailBinding = (objParam = {}) => post('/ClueGmail/Disconnect', objParam, GMAIL_REQUEST_OPTIONS);
// 获取客户 Gmail 线程列表
export const GetGmailThreads = (objParam = {}) => get('/ClueGmail/GetThreads', objParam, GMAIL_REQUEST_OPTIONS);
// 获取客户 Gmail 线程详情
export const GetGmailThreadDetail = (objParam = {}) => get('/ClueGmail/GetThreadDetail', objParam, GMAIL_REQUEST_OPTIONS);
// 发送首封 Gmail
export const SendGmailMail = (objParam = {}) => post('/ClueGmail/SendMail', objParam, GMAIL_REQUEST_OPTIONS);
// 在线程中回复 Gmail
export const ReplyGmailMail = (objParam = {}) => post('/ClueGmail/ReplyMail', objParam, GMAIL_REQUEST_OPTIONS);
// 更新群聊运营
export const weChatUpdateGroupChatOperator = (objParam) => post('/WeChatDetail/weChatUpdateGroupChatOperator', objParam);
// 沟通记录
export const GetCommunicateRecords = (objParam) => get('/ClueRecords/GetCommunicateRecords', objParam);
// 行为记录
// export const GetCommunicateRecordsForAction = (objParam) => get('/ClueFollow/GetCommunicateRecordsForAction', objParam);
// 区域信息
export const GetArea = () => get('/Area/GetAreaWithCity', objParam);
export const getLeadAreas = (objParam = {}) => get('/Area/GetLeadAreas', objParam);
// 学校查询
export const getSchools = (objParam) => get('/Area/getSchools', objParam);
// 职业状
export const professionalStatus = (objParam) => get('Dictionary/GetDictionaryByTypeId?dicType=10006', objParam);
// 学历
export const RecordSchooling = (objParam) => get('/Dictionary/GetDictionaryByTypeId?dicType=10025', objParam);
// 话务状态
export const callTrafficStatus = (objParam) => get('/Dictionary/GetDictionaryByTypeId?dicType=1021', objParam);
// 意向学科
export const interestedProject = (objParam) => get('/DataStru/GetCurrentUserCourseTypeList', objParam);

//感兴趣项目 非权限验证
export const interestedProjectNoAuth = (objParam) => get('/Dictionary/GetDictionaryByTypeId?dicType=1602');
//  客户意向

export const intentionDegree = (objParam) => get('/Dictionary/GetDictionaryByTypeId?dicType=1020', objParam);
// 客户意向
export const IntentionStudents = () => get('/Dictionary/GetDictionaryByTypeId?dicType=10010', objParam);


//  客户状
export const cluesStatus = (objParam) => get('/Dictionary/GetDictionaryByTypeId?dicType=10021', objParam);
//  客户分配
export const Distribute = (objParam) => post('/ClueOwner/ReceiveDistribute', {
    ...objParam,
    // innerUrl: '/ClueDistribute/Distribute'
});
//  分配销售
export const DistributeSale = (objParam) => post('/ClueDistribute/DistributeSale', {
    ...objParam,
    // innerUrl: '/ClueDistribute/Distribute'
});
//  分配TMK
export const DistributeTMK = (objParam) => post('/ClueDistribute/DistributeTMK', {
    ...objParam,
    // innerUrl: '/ClueDistribute/Distribute'
});
//  分配CR
export const DistributeCR = (objParam) => post('/ClueDistribute/DistributeCr', {
    ...objParam,
    // innerUrl: '/ClueDistribute/Distribute'
});
//移入公海池
export const KickCluePool = (objParam) => post('/ClueDistribute/KickPool', {
    // ...objParam,
    // innerUrl: '/ClueDistribute/KickPool'
    ...objParam,
});
//放入黑名单
export const KickBlackList = (objParam) => post('/ClueDistribute/KickBlackList', {
    // ...objParam,
    // innerUrl: '/ClueDistribute/KickPool'
    ...objParam,
});
// 合作校退回到线上接口
export const DistributeOnLine = (objParam) => post('/ClueDistribute/DistributeOnLine', objParam);
// 客户分配人员
export const GetAllowedUserTree = (objParam) => get('/DataStru/GetUserDepartmentTree', objParam);

// 客户关联营销活动
export const SetSourceDetails = (params) => post('/Clue/SetSourceDetails', {
    ...params,
    innerUrl: '/Clue/SetSourceDetails'
});
// 客户定向分配人员
export const GetDirectionalTree = () => get('/DataStru/GetDirectionalTree', objParam);
//获取公池树
export const GetPublicPoolUser = () => get('/DataStru/GetDepartmentPublicUserTree', objParam);
//获取部门树
export const GetOrganizeTree = () => get('/DataStru/GetOrganizeTree', objParam);
//  客户新增
export const AddClueInfo = (objParam) => post('/Clue/AddClueInfo', objParam);
//  根据手机号码获取推荐人信息
export const GetRecommendCustomers = (objParam) => get('/ClueFollow/GetRecommendCustomers', objParam);
// 模糊查询
export const ClueVagueSeachList = (objParam) => post('/Clue/ClueVagueSeachList', objParam);
// 国家电话号码区号
export const GetCountryPhoneCodeList = () => post('/Area/GetCountryPhoneCodeList', objParam);
// 优质客户类型
export const OptimalCluesType = () => get('/Dictionary/GetDictionaryByTypeId?dicType=5043', objParam);
// 有效渠道
export const getchannels = () => get('/Channel/getchannels', objParam);
//渠道模糊搜索
export const GetChannelListByName = (objParam = {}) => {
    return get('/Channel/GetChannelListByName', objParam);
}

// 获取推荐渠道
export const GetRecommendChannels = () => get('Channel/GetRecommendChannels', objParam);

// 客户导入
export const ImportClues = () => post('/ClueBatch/ImportClues', objParam);
// 电话
export const sendCall = (objParam) => post('/api/call/send_call', objParam);
// 共享客户
export const SearchShareClue = (objParam) => get('/ClueOwner/SearchShareClue', objParam);
//所属人查询
export const getClueOwner = (objParam) => get('/ClueOwner/SearchClueOwner', objParam);
// 销售客户跟进
export const GeCluFollowSeniorSearchList = (objParam) => post('/ClueFollow/GeCluFollowSeniorSearchList', objParam);
// 客户详情 紧急联系人
export const ClueDetail = (objParam) => get('/ClueFollow/ClueDetail', objParam);
// 客户详情 流转记录
export const ClueTurnRecords = (objParam) => get('/ClueRecords/ClueTurnRecords', objParam);
// 客户详情 重复咨询
export const RepeateConsult = (objParam) => get('/ClueRecords/RepeateConsult', objParam);
//试听记录
export const ListenInvitationRecords = (objParam) => get('/ClueRecords/ListenInvitationRecords', objParam);
// 通话记录
export const getPhoneRecords = (objParam) => get('/ClueRecords/PhoneRecords', objParam);
// 获取散客邀约记录
export const GetIndividualRecords = (objParam) => get('/ClueRecords/GetIndividualRecords', objParam);
// 推荐记录
export const GetClueRecommendRecord = (objParam) => get('/ClueRecords/GetClueRecommendRecord', objParam);

//带参数的所有城市或者省份
export const getProviceOrCity = (objParam) => get('/Area/GetArea', objParam);
export const getAreas = (objParam) => get('/Area/GetAreas', objParam);
//客户分配规则新增
export const AddAllocation = (objParam) => post('/Allocation/AddAllocation', objParam);
//客户分配规则列表
export const GetAllocationRuleList = (objParam) => post('/Allocation/GetAllocationRuleList', objParam);
//客户分配规则编辑
export const EditAllocation = (objParam) => post('/Allocation/EditAllocation', objParam);
//客户分配删除
export const DisableAllocation = (objParam) => post('/Allocation/DisableAllocation', objParam);
//客户分配规则详情
export const GetAllocationRuleInfo = (objParam) => get('/Allocation/GetAllocationRuleInfo', objParam);
//快速搜索规则
export const GetQuickAllocationRuleList = (objParam) => post('/Allocation/GetQuickAllocationRuleList', objParam);
//获取当前登录用户的部门人员
export const GetUserDepartment = (objParam) => get('/UserInfo/GetUserDepartment', objParam);
// 客户跟进(客户类型)统计
export const GetClueFollowCountByClueQualityList = () => post('/ClueFollow/GetClueFollowCountByClueQualityList', objParam);
// 客户跟进模糊查询
export const ClueFollowVagueSeachList = (objParam) => post('/ClueFollow/ClueFollowVagueSeachList', objParam);

//客户回收列表
export const GetRecoveryRuleList = (objParam) => post('/Recovery/GetRecoveryRuleList', objParam);

//客户回收编辑
export const EditRecovery = (objParam) => post('/Recovery/EditRecovery', objParam);
//客户回收新增
export const AddRecovery = (objParam) => post('/Recovery/AddRecovery', objParam);
//客户回收禁用和停用
export const DeDisableRecovery = (objParam) => post('/Recovery/DeDisableRecovery', objParam);
//客户回收详情
export const GetRecoveryRuleInfo = (objParam) => get('/Recovery/GetRecoveryRuleInfo', objParam);
//客户快速查询
export const GetQuickRecoveryRuleList = (objParam) => post('/Recovery/GetQuickRecoveryRuleList', objParam);

//客户状态列表2
export const GetClueTypeEnumList = (objParam) => get('/DataStru/GetClueTypeEnumList', objParam);
//客户状态1
export const GetClueStatusTree = () => get('/Clue/GetClueStatusTree', objParam);

//获取所有部门下的人员和部门
export const GetDepartmentTree = (objParam) => get('DataStru/GetDepartmentTree', objParam);

//获取当前登录人所属部门下的人和部门
export const GetUserDepartmentTree = (objParam) => get('DataStru/GetUserDepartmentTree', objParam);

//分配类型条件列表
export const GetRangeFieldEnumList = () => get('DataStru/GetRangeFieldEnumList', objParam);
//分配对象
export const GetRationTypeEnumList = () => get('DataStru/GetRationTypeEnumList', objParam);
//分配条件包含，排除状态
export const GetContainStateEnumList = () => get('DataStru/GetContainStateEnumList', objParam);
//分配条件有效，停用状态
export const GetDataTypeEnumList = () => get('DataStru/GetDataTypeEnumList', objParam);
//获取人员id,上级部门id
export const GetUserDepartNode = (objParam) => get('UserInfo/GetUserDepartNode', objParam);
//获取试听列表
export const GetListenList = (objParam) => post('/ListenInvitation/GetListenList', objParam);
//获取试听课操作日志记录
export const GetOperateRecordList = (objParam) => post('/ListenInvitation/GetOperateRecordList', objParam);
//营销计划
export const GetSourceDetailsTree = () => get('/Channel/GetSourceDetailsTree', objParam);
//客户来源
export const GetCustomerSourceTree = () => get('/Channel/GetCustomerSourceTree', objParam);
//客户来源
export const GetCustomerSourceTreeByWhere = (objParam) => post('/Channel/GetCustomerSourceTreeByWhere', objParam);
// 学校
export const getValueSchools = (objParam) => get('/Area/getValueSchools', objParam);
// 获取报名记录
export const GetOrderRecord = (objParam) => get('/ClueRecords/GetOrderRecord', objParam);
// 客户跟进数量
export const GetClueAllCount = (objParam) => get('/ClueRecords/GetClueAllCount', objParam);
// 推荐人搜索
export const GetRecommenderSearchList = (objParam) => get('/SalesManagement/GetRecommenderList', objParam);
// 是否共享客户
export const GetIsShareClueByClueGuid = (objParam) => post('/Clue/GetIsShareClueByClueGuid', objParam);
// 获取自定义列信息
export const GetBase_PageFieldConfig = (objParam) => get('/BasePageConfig/GetBase_PageFieldConfig', objParam);
// 新增自定义显示列
export const AddBase_PageFieldConfig = (objParam) => post('/BasePageConfig/AddBase_PageFieldConfig', objParam);
// 客户跟进页修改联系方式
export const getModifyCustom = (objParam) => post('/ClueFollow/ModifyCustom', objParam);
// 停用或启用一个分配规则
export const getDisableAllocation = (objParam) => post('/Allocation/DisableAllocation', objParam);
// 获取标签
export const GetLabelList = () => get('/Label/GetLabelList');
// 批量设置标签
const SetClueLabelParam = {
    LabelIdList: [],
    ClueGuidList: []
}
export const SetClueLabel = (SetClueLabelParam) => post('/Label/SetClueLabel', {
    ...SetClueLabelParam
    // innerUrl: '/Label/SetClueLabel'
});
// 根据客户guid列表获取关联标签
const ClueGuidList = []
export const GetClueLabelList = (ClueGuidList) => post('/Label/GetClueLabelList', ClueGuidList);
// 获取未读消息数量
export const GetUnreadMessageCount = () => get('/Message/GetUnreadMessageCount');
//根据客户guid获取全部的沟通记录
export const GetCommucinateContentList = clueGuid => get('/ClueOwner/GetCommucinateContentList', {
    clueGuid
});

//设置主号码
export const SetMainPhone = (objParam) => post('/ClueFollow/SetMainPhone', objParam);
//根据名称模糊查询协作人
export const GetAssociatesList = (objParam) => get('/UserInfo/GetAssociatesList', objParam);
// 客户管理列表
export const GetEsClueBaseList = (objParam) => post('/clue/GetEsClueBaseList', objParam);

// 查询客户上限
export const QueryClueUpperLimit = (objParam) => post('/Clue/GetClueQtyLimitList', objParam)
// 修改客户上限
export const UpdataClueUpperLimit = (objParam) => post('/Clue/UpdateClueQtyLimit', objParam)

// 获取业绩列表
export const GetPerformanceList = (objParam) => post('PerformanceObjectives/GetPerformanceObjectivesList', objParam)

// 新增或更新业绩列表
export const UpdatePerformanceList = (objParam) => post('PerformanceObjectives/UpdatePerformanceObjectives', objParam)

/* 白名单 start */
// 查询白名单
export const QueryWhiteList = (objParam) => post('IpAddressWhiteList/GetIpAddressWhiteList', objParam)

// 新增白名单
export const AddWhiteItem = (objParam) => post('IpAddressWhiteList/AddIpAddressWhiteList', objParam)

// 修改白名单
export const UpdateWhiteItem = (objParam) => post('IpAddressWhiteList/UpdateIpAddressWhiteList', objParam)

// 查询白名单
export const QueryWhiteItemById = (objParam) => post('IpAddressWhiteList/GetIpAddressWhiteListById', objParam)
/* 白名单 end */

/* 创建订单start */
//根据线索获取客户信息
export const GetStudentInfo = (objParam) => post('OrderCenter/GetStudentInfo', objParam)
export const CreateOrder = (objParam) => post('ordercenter/CreateOrder', objParam)
export const UpdateOrder = (objParam) => post('OrderCenter/UpdateOrder', objParam)

//优惠信息
export const GetDiscountByCourseType = (objParam) => post('ProductCenter/GetDiscountByCourseType', objParam)

export const ComputeDiscount = (objParam) => post('OrderCenter/ComputeDiscount', objParam)

/* 创建订单end */

/* 联系人修改 start */
// 查询联系方式
export const GetCustomContacts = (objParam) => get('CustomCenter/GetCustomContacts', objParam)

// 修改联系方式
export const ModifyCusotmContacts = (objParam) => post('/CustomCenter/ModifyCusotmContacts', objParam)

// 修改客户名称
export const ModifyCustomName = (objParam) => post('/CustomCenter/ModifyCustomName', objParam)
// 自定义显示列
export const EsSelfSearch = (objParam) => post('/EsSearch/EsSelfSearch', objParam)
// 发送客户跟进短信
export const SendClueFollowShortMessage = (objParam) => post('/Clue/SendClueFollowShortMessage', objParam)
// 删除客户联系人
export const DeleteCustomContacts = (objParam) => get('/CustomCenter/DeleteCustomContacts', objParam)
/* 联系人修改 end */

// 根据学校校名获取学ID
export const GetSchoolListByName = (objParam) => post('/Area/GetSchoolListByName', objParam)


/* 合同模板 start */
// 获取合同模板列表
export const GetContractTemplateList = (objParam) => post('/ContractTemplate/GetContractTemplateByWhere', objParam)

// 新增合同模板
export const AddContractTemplate = (objParam) => post('/ContractTemplate/AddContractTemplate', objParam)

// 修改合同模板
export const UpdateContractTemplate = (objParam) => post('/ContractTemplate/UpdateContractTemplate', objParam)

// 按id查询指定一条合同模板
export const GetContractTemplateById = (objParam) => post('/ContractTemplate/GetContractTemplateById', objParam)

// 获取指定项目下有效的协议列表
export const GetContractTemplateForProduct = (objParam) => post('/ContractTemplate/GetContractTemplateForProduct', objParam)


export const GetSourceDetailsByDetailName = (objParam) => get('SourceDetails/GetSourceDetailsByDetailName', objParam)
// 根据关键字DetailName获取营销计划列表id
export const GetSourceDetailsByDetailNames = (objParam) => post('SourceDetails/GetSourceDetailsByDetailNames', objParam)
// 是否备案
export const SetCluePrivatePool = (objParam) => get('ClueFollow/SetCluePrivatePool', objParam)
// 是否备案
export const GetProvinceTreeList = objParam => post('/ReportPower/GetProvinceTreeList', objParam)

// 补省市
export const CluePhoneMatchProvince = (objParam) => post('Clue/CluePhoneMatchProvince', objParam)

// 获取特殊试听申请列表
export const ClusSpeShitingApply = (objParam) => post('ListenInvitation/GetListenApplyList', objParam)

// 转项目
export const ChangeCourseType = (objParam) => post('Clue/ChangeCourseType', objParam)

// 查询客户信息
export const GetClueMergerInfo = (objParam) => post('Clue/GetClueMergerInfo', objParam)

// 合并项目
export const ClueMerger = (objParam) => post('Clue/ClueMerger', objParam)

// 获取微信沟通记录列表
export const GetWechatRecords = (objParam) => get('WeChatMain/GetWechatRecords', objParam)

// 微信沟通记录详情
export const SearchWechatDetails = (objParam) => post('WeChatMain/SearchWechatDetails', objParam)

// 查询所有标签
export const QueryAllLabel = (objParam) => post('WeChatConnect/QueryAllLabel', objParam)

// 我的好友绑定解绑微信
export const BindFriendCustomer = (objParam) => post('WeChatConnect/BindFriendCustomer', objParam)

// 导出聊天记录
export const exportChat = (objParam) => post('WeChatDetail/exportChat', objParam)

// 放入公海池记录
export const GetCluePoolRecords = (objParam) => get('ClueRecords/GetCluePoolRecords', objParam)

// 获取dl测评报告
export const GetDlReportList = (objParam) => get('ClueRecords/GetDlReportList', objParam)

// TMK审核
export const AuditTmkClueFollowInfo = (objParam) => post('ClueFollow/AuditTmkClueFollowInfo', objParam)

// 客户转推荐
export const SaveRecommendingClue = (objParam) => post('/Clue/SaveRecommendingClue', objParam);

//获取试听课
export const GetShitingCourse = (objParam) => post('/ListenInvitation/GetShiTingCourseList', objParam);

//获取试听课时间段
export const GetShitingCourseTime = (objParam) => post('/ListenInvitation/GetShiTingTimeAearList', objParam);

//获取试听课老师
export const GetShitingCourseTeacher = (objParam) => post('/ListenInvitation/GetShiTingTeacherList', objParam);
//获取试听课空闲列表
export const GetShiTingCalendar = (objParam) => post('/ListenInvitation/GetShiTingCalendar', objParam);

//添加常规试听邀约
export const AddShitingCourseConfirm = (objParam) => post('/ListenInvitation/AddListenInvitation', objParam);

//添加特殊试听邀约
export const AddShitingCourseTs = (objParam) => post('/ListenInvitation/AddListenInvitationApply', objParam);

// 取消试听
export const CancelShiting = (objParam) => get('/ListenInvitation/CanleListenInvitation', objParam)

//重新邀约
export const RestartInvite = (objParam) => post('/ListenInvitation/ReListenInvitation', objParam);

// 获取试听信息
export const GetShitingInfo = (objParam) => get('/ListenInvitation/GetListenListInfo', objParam)

// 模糊搜索学校
export const GetSchoolByCityId = (objParam) => get('/School/GetSchoolByCityId', objParam)

// 根据学校id 获取校区信息
export const GetCampusBySchoolId = (objParam) => get('/School/GetCampusBySchoolId', objParam)

//编辑试听邀约
export const EditShitingInvite = (objParam) => post('/ListenInvitation/ReListenInvitation', objParam);

//编辑热度
export const UpdateListenHot = (objParam) => post('/ListenInvitation/UpdateListenHot', objParam);

//特殊试听申请审核
export const ShenheShitingInvite = (objParam) => post('/ListenInvitation/AuditListenInvitationApply', objParam);

//老师模糊搜索
export const GetTeacherList = (objParam) => get('/Teacher/SearchTeacher', objParam);

export const startTableList = [{"X":"2018-10-08","Y":[{"TimeArea":"08:45 - 09:30","DisEnable":false,"TeacherCount":0},{"TimeArea":"09:30 - 10:15","DisEnable":false,"TeacherCount":0},{"TimeArea":"10:15 - 11:00","DisEnable":false,"TeacherCount":0},{"TimeArea":"11:00 - 11:45","DisEnable":false,"TeacherCount":0},{"TimeArea":"11:45 - 12:30","DisEnable":false,"TeacherCount":0},{"TimeArea":"13:00 - 13:45","DisEnable":false,"TeacherCount":0},{"TimeArea":"13:45 - 14:30","DisEnable":false,"TeacherCount":0},{"TimeArea":"14:30 - 15:15","DisEnable":false,"TeacherCount":0},{"TimeArea":"15:15 - 16:00","DisEnable":false,"TeacherCount":0},{"TimeArea":"16:00 - 16:45","DisEnable":false,"TeacherCount":0},{"TimeArea":"16:45 - 17:30","DisEnable":false,"TeacherCount":0},{"TimeArea":"18:00 - 18:45","DisEnable":false,"TeacherCount":0},{"TimeArea":"18:45 - 19:30","DisEnable":false,"TeacherCount":0},{"TimeArea":"19:30 - 20:15","DisEnable":false,"TeacherCount":0},{"TimeArea":"20:15 - 21:00","DisEnable":false,"TeacherCount":0},{"TimeArea":"21:00 - 21:45","DisEnable":false,"TeacherCount":0}]},{"X":"2018-10-09","Y":[{"TimeArea":"08:45 - 09:30","DisEnable":false,"TeacherCount":0},{"TimeArea":"09:30 - 10:15","DisEnable":false,"TeacherCount":0},{"TimeArea":"10:15 - 11:00","DisEnable":false,"TeacherCount":0},{"TimeArea":"11:00 - 11:45","DisEnable":false,"TeacherCount":0},{"TimeArea":"11:45 - 12:30","DisEnable":false,"TeacherCount":0},{"TimeArea":"13:00 - 13:45","DisEnable":false,"TeacherCount":0},{"TimeArea":"13:45 - 14:30","DisEnable":false,"TeacherCount":0},{"TimeArea":"14:30 - 15:15","DisEnable":false,"TeacherCount":0},{"TimeArea":"15:15 - 16:00","DisEnable":false,"TeacherCount":0},{"TimeArea":"16:00 - 16:45","DisEnable":false,"TeacherCount":0},{"TimeArea":"16:45 - 17:30","DisEnable":false,"TeacherCount":0},{"TimeArea":"18:00 - 18:45","DisEnable":false,"TeacherCount":0},{"TimeArea":"18:45 - 19:30","DisEnable":false,"TeacherCount":0},{"TimeArea":"19:30 - 20:15","DisEnable":false,"TeacherCount":0},{"TimeArea":"20:15 - 21:00","DisEnable":false,"TeacherCount":0},{"TimeArea":"21:00 - 21:45","DisEnable":false,"TeacherCount":0}]},{"X":"2018-10-10","Y":[{"TimeArea":"08:45 - 09:30","DisEnable":false,"TeacherCount":0},{"TimeArea":"09:30 - 10:15","DisEnable":false,"TeacherCount":0},{"TimeArea":"10:15 - 11:00","DisEnable":false,"TeacherCount":0},{"TimeArea":"11:00 - 11:45","DisEnable":false,"TeacherCount":0},{"TimeArea":"11:45 - 12:30","DisEnable":false,"TeacherCount":0},{"TimeArea":"13:00 - 13:45","DisEnable":false,"TeacherCount":0},{"TimeArea":"13:45 - 14:30","DisEnable":false,"TeacherCount":0},{"TimeArea":"14:30 - 15:15","DisEnable":false,"TeacherCount":0},{"TimeArea":"15:15 - 16:00","DisEnable":false,"TeacherCount":0},{"TimeArea":"16:00 - 16:45","DisEnable":false,"TeacherCount":0},{"TimeArea":"16:45 - 17:30","DisEnable":false,"TeacherCount":0},{"TimeArea":"18:00 - 18:45","DisEnable":false,"TeacherCount":0},{"TimeArea":"18:45 - 19:30","DisEnable":false,"TeacherCount":0},{"TimeArea":"19:30 - 20:15","DisEnable":false,"TeacherCount":0},{"TimeArea":"20:15 - 21:00","DisEnable":false,"TeacherCount":0},{"TimeArea":"21:00 - 21:45","DisEnable":false,"TeacherCount":0}]},{"X":"2018-10-11","Y":[{"TimeArea":"08:45 - 09:30","DisEnable":false,"TeacherCount":0},{"TimeArea":"09:30 - 10:15","DisEnable":false,"TeacherCount":0},{"TimeArea":"10:15 - 11:00","DisEnable":false,"TeacherCount":0},{"TimeArea":"11:00 - 11:45","DisEnable":false,"TeacherCount":0},{"TimeArea":"11:45 - 12:30","DisEnable":false,"TeacherCount":0},{"TimeArea":"13:00 - 13:45","DisEnable":false,"TeacherCount":0},{"TimeArea":"13:45 - 14:30","DisEnable":false,"TeacherCount":0},{"TimeArea":"14:30 - 15:15","DisEnable":false,"TeacherCount":0},{"TimeArea":"15:15 - 16:00","DisEnable":false,"TeacherCount":0},{"TimeArea":"16:00 - 16:45","DisEnable":false,"TeacherCount":0},{"TimeArea":"16:45 - 17:30","DisEnable":false,"TeacherCount":0},{"TimeArea":"18:00 - 18:45","DisEnable":false,"TeacherCount":0},{"TimeArea":"18:45 - 19:30","DisEnable":false,"TeacherCount":0},{"TimeArea":"19:30 - 20:15","DisEnable":false,"TeacherCount":0},{"TimeArea":"20:15 - 21:00","DisEnable":false,"TeacherCount":0},{"TimeArea":"21:00 - 21:45","DisEnable":false,"TeacherCount":0}]},{"X":"2018-10-12","Y":[{"TimeArea":"08:45 - 09:30","DisEnable":false,"TeacherCount":0},{"TimeArea":"09:30 - 10:15","DisEnable":false,"TeacherCount":0},{"TimeArea":"10:15 - 11:00","DisEnable":false,"TeacherCount":0},{"TimeArea":"11:00 - 11:45","DisEnable":false,"TeacherCount":0},{"TimeArea":"11:45 - 12:30","DisEnable":false,"TeacherCount":0},{"TimeArea":"13:00 - 13:45","DisEnable":false,"TeacherCount":0},{"TimeArea":"13:45 - 14:30","DisEnable":false,"TeacherCount":0},{"TimeArea":"14:30 - 15:15","DisEnable":false,"TeacherCount":0},{"TimeArea":"15:15 - 16:00","DisEnable":false,"TeacherCount":0},{"TimeArea":"16:00 - 16:45","DisEnable":false,"TeacherCount":0},{"TimeArea":"16:45 - 17:30","DisEnable":false,"TeacherCount":0},{"TimeArea":"18:00 - 18:45","DisEnable":false,"TeacherCount":0},{"TimeArea":"18:45 - 19:30","DisEnable":false,"TeacherCount":0},{"TimeArea":"19:30 - 20:15","DisEnable":false,"TeacherCount":0},{"TimeArea":"20:15 - 21:00","DisEnable":false,"TeacherCount":0},{"TimeArea":"21:00 - 21:45","DisEnable":false,"TeacherCount":0}]},{"X":"2018-10-13","Y":[{"TimeArea":"08:45 - 09:30","DisEnable":false,"TeacherCount":0},{"TimeArea":"09:30 - 10:15","DisEnable":false,"TeacherCount":0},{"TimeArea":"10:15 - 11:00","DisEnable":false,"TeacherCount":0},{"TimeArea":"11:00 - 11:45","DisEnable":false,"TeacherCount":0},{"TimeArea":"11:45 - 12:30","DisEnable":false,"TeacherCount":0},{"TimeArea":"13:00 - 13:45","DisEnable":false,"TeacherCount":0},{"TimeArea":"13:45 - 14:30","DisEnable":false,"TeacherCount":0},{"TimeArea":"14:30 - 15:15","DisEnable":false,"TeacherCount":0},{"TimeArea":"15:15 - 16:00","DisEnable":false,"TeacherCount":0},{"TimeArea":"16:00 - 16:45","DisEnable":false,"TeacherCount":0},{"TimeArea":"16:45 - 17:30","DisEnable":false,"TeacherCount":0},{"TimeArea":"18:00 - 18:45","DisEnable":false,"TeacherCount":0},{"TimeArea":"18:45 - 19:30","DisEnable":false,"TeacherCount":0},{"TimeArea":"19:30 - 20:15","DisEnable":false,"TeacherCount":0},{"TimeArea":"20:15 - 21:00","DisEnable":false,"TeacherCount":0},{"TimeArea":"21:00 - 21:45","DisEnable":false,"TeacherCount":0}]},{"X":"2018-10-14","Y":[{"TimeArea":"08:45 - 09:30","DisEnable":false,"TeacherCount":0},{"TimeArea":"09:30 - 10:15","DisEnable":false,"TeacherCount":0},{"TimeArea":"10:15 - 11:00","DisEnable":false,"TeacherCount":0},{"TimeArea":"11:00 - 11:45","DisEnable":false,"TeacherCount":0},{"TimeArea":"11:45 - 12:30","DisEnable":false,"TeacherCount":0},{"TimeArea":"13:00 - 13:45","DisEnable":false,"TeacherCount":0},{"TimeArea":"13:45 - 14:30","DisEnable":false,"TeacherCount":0},{"TimeArea":"14:30 - 15:15","DisEnable":false,"TeacherCount":0},{"TimeArea":"15:15 - 16:00","DisEnable":false,"TeacherCount":0},{"TimeArea":"16:00 - 16:45","DisEnable":false,"TeacherCount":0},{"TimeArea":"16:45 - 17:30","DisEnable":false,"TeacherCount":0},{"TimeArea":"18:00 - 18:45","DisEnable":false,"TeacherCount":0},{"TimeArea":"18:45 - 19:30","DisEnable":false,"TeacherCount":0},{"TimeArea":"19:30 - 20:15","DisEnable":false,"TeacherCount":0},{"TimeArea":"20:15 - 21:00","DisEnable":false,"TeacherCount":0},{"TimeArea":"21:00 - 21:45","DisEnable":false,"TeacherCount":0}]}]

//获取放入公海池原因类型
export const GetCluePoolReasonTypeList = (objParam) => get('/ClueFollow/GetCluePoolReasonTypeList', objParam);
// //获取放入公海池原因类型
// export const KickPool = (objParam) => get('/ClueDistribute/KickPool', objParam);

// TMK等级
export const GetTMKLevelEnumList = (objParam) => get('/DataStru/GetTMKLevelEnumList', objParam)
// 渠道等级
export const GetChannlLevelEnumList = (objParam) => get('/DataStru/GetChannlLevelEnumList', objParam)
// 修改目标周
export const UpdateTargetWeek = (objParam) => post('/PerformanceObjectives/UpdateTargetWeek', objParam)

//获取会议邀约记录
export const GetMeetingInviteRecrods = (objParam) => post('/MeetingInvite/GetMeetingInviteList', objParam)

//获取订单详情
export const OrderDetail = (objParam) => get('/ERPMarketResearch/GetCOrderByClueGuid', objParam);

//更改市调状态
export const CloseMarketResearch = (objParam) => post('/ERPMarketResearch/CloseMarketResearch',objParam);
//获取市调记录
export const GetMResearchRecord = (objParam) => get('/ERPMarketResearch/GetMResearchByClueGuid', objParam);

export const GetCustomTelById = (objParam) => get('ERPMarketResearch/GetCustomTelById', objParam);

export const PublicSchoolSearch = (objParam) => post('/ERPPublicSchool/PublicSchoolSearch', objParam);

// 获取一体化服务
export const GetInviteServiceItemTree = (objParam) => get('/BaseServiceItem/GetInviteServiceItemTree', objParam);

//获取邀约服务反馈信息
export const GetInviteServiceItems = (objParam) => get('/MeetingInvite/GetInviteServiceItems', objParam);

// 新增邀约服务反馈信息
export const AddInviteServiceItem = (objParam) => post('/MeetingInvite/AddInviteServiceItem', objParam);

// 获取邀约服务反馈内容列表
export const GetInviteServiceItemList = (objParam) => post('/MeetingInvite/GetInviteServiceItemList', objParam);

// 获取Sop推送记录
export const GetClueSopRecords = (objParam) => get('/ClueRecords/GetClueSopRecords', objParam);

// 获取行为数据记录
export const GetClueActionRecords = (objParam) => get('/ClueRecords/GetClueActionRecords', objParam);
// 字典-客户等级获取
export const GetLevelList = (objParam) => get('/DataStru/GetLevelList', objParam);
// 客户等级记录
export const GetCustomLevelRecords = (objParam) => get('/ClueRecords/GetCustomLevelRecords', objParam);

// 根据意向度获取等级list
export const GetLevels = (objParam) => get('/DataStru/GetLevels', objParam);
// 保存到运营
export const AddClueOperator = (objParam) => get('/ClueFollow/AddClueOperator', objParam);
// 查询客户信息
export const GetClueInfo = (objParam) => get('/WeChatConnect/GetClueInfo', objParam);
// 获取会话统计通过客户微信id
export const getWeChatStatisticByClueGuid = (objParam) => get('/WeChatDetail/getWeChatStatisticByClueGuid', objParam);
// 我的客户查询
export const MyCustomer = (objParam) => get('/WeChatConnect/MyCustomer', objParam);
// 查询群聊
export const selectWeChatGroupChat = (objParam) => post('/WeChatDetail/selectWeChatGroupChat', objParam);
// 更新群聊状态
export const updateWeChatGroupChatStatus = params => post(   `WeChatDetail/updateWeChatGroupChatStatus?chatId=${params.chatId}&&status=${params.status}`, params);

// 查询会话列表
export const selectWeChatChatList = (objParam) => post('/WeChatDetail/selectWeChatChatList', objParam);

// 查询会议签到明细
export const QueryMeetingSignDetail = (objParam) => post('/MiniProgram/QueryMeetingSignDetail', objParam);

// 查询会议签到明细 导出
export const QueryMeetingSignDetailExport = (objParam) => post('/MiniProgram/QueryMeetingSignDetailExport', objParam);

// 获取跟进汇总数据
export const QueryFollowUpDate = (objParam) => post('/MiniProgram/QueryFollowUpDate', objParam);

// 跟进汇总数据导出
export const QueryFollowUpDateExport = (objParam) => post('/MiniProgram/QueryFollowUpDateExport', objParam);

// 业绩明细明细数据 
export const AchievementList = (objParam) => post('/MiniProgram/AchievementList', objParam);

// 业绩明细明细数据导出
export const AchievementListExport = (objParam) => post('/MiniProgram/AchievementListExport', objParam);

// 获取跟进明细数据 
export const QueryFollowUpDetailDate = (objParam) => post('/MiniProgram/QueryFollowUpDetailDate', objParam);

// 跟进数据明细导出 
export const QueryFollowUpDetailDateExport = (objParam) => post('/MiniProgram/QueryFollowUpDetailDateExport', objParam);

// 统计日报
export const statDailyReports = (objParam) => post('/MiniProgram/statDailyReports', objParam);

// 统计日报导出
export const statDailyReportsExport = (objParam) => post('/MiniProgram/statDailyReportsExport', objParam);

// 共享客户-预分配
export const AssignPreview = (objParam) => post(`/clue/share/assign/preview`, objParam)

// 共享客户-分配
export const AssignSave = (objParam) => post(`/clue/share/assign/save`, objParam)


// 按渠道统计数据
export const groupByChannel = (objParam) => post(`/clue/track/report/groupByChannel`, objParam)

// 渠道类型下拉框 - 通过上级ID查询
export const getByPid = (objParam) => post(`/channel/label/channelType/getByPid`, objParam)

// 渠道下拉框 - 通过渠道类型ID查询
export const getByTypeId = (objParam) => post(`/channel/label/channel/getByTypeId`, objParam)

// 获取团队部门列表
export const getTeams = (objParam) => post(`/clue/track/report/teams`, objParam)

// 获取小组列表
export const getTeamstmk = (objParam) => post(`/clue/track/report/teamstmk`, objParam)

// 获取团队成员列表
export const getMembers = (objParam) => post(`/clue/track/report/members`, objParam)

// 团队数据统计
export const getGroupByTeam = (objParam) => post(`/clue/track/report/groupByTeam`, objParam)

// 成员数据统计
export const getGroupByMember = (objParam) => post(`/clue/track/report/groupByMember`, objParam)

// 检查线索是否已指定团队
export const checkHasBelong = (objParam) => post(`/clue/belongTeam/checkHasBelong`, objParam)

// 指定线索团队
export const handBelongTeam = (objParam) => post(`/clue/belongTeam/handBelongTeam`, objParam)

// 线索导出
export const exportEsClue = (objParam) => post(`/api/clue/manage/v1/exportEsClue`, objParam)

// 线索导出
export const exportByChannel = (objParam) => post(`/clue/track/report/exportByChannel`, objParam)
// 线索导出
export const exportByTeam = (objParam) => post(`/clue/track/report/exportByTeam`, objParam)
// 线索导出
export const exportByMember = (objParam) => post(`/clue/track/report/exportByMember`, objParam)
// 获取渠道树
export const GetChannelTree = (objParam) => get('/channel/label/channel/getTree', objParam);
